import type { FC, PropsWithChildren } from 'react';

import clsx from 'clsx';

interface IconBeforeProps {
  className: string;
}

export const IconBefore: FC<PropsWithChildren<IconBeforeProps>> = ({ children, className }) => {
  return <span className={clsx('mr-2 h-4 w-4', className)}>{children}</span>;
};
